"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/ConfirmEmailScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);

var _AuthFrame = require('web/components/AuthFrame');
var _Spinner = require('web/components/Spinner');








const errorMsgs = {
  'Invalid Token': 'Sorry, this link has expired. We just sent you a new email confirmation link. Please allow a few minutes for it to arrive.',
  'Cannot steal primary email': 'Sorry, this email address is already being used as the primary email address on another account. Please log in to that account and remove the email before attempting to add it to this account.',
  'generic': 'Sorry, BloomText has encountered an error. Please try again later or contact support@bloomtext.com.',
}

const ConfirmEmailScreen = () => {
  const [isLoading, setIsLoading] = _react.useState.call(void 0, true)
  const [errorMsg, setErrorMsg] = _react.useState.call(void 0, '')

  const match = _reactrouterdom.useRouteMatch(_routes2.default.CONFIRM_EMAIL)
  const token = _optionalChain([match, 'optionalAccess', _ => _.params, 'optionalAccess', _2 => _2.token]) || ''

  _react.useEffect.call(void 0, 
    () => {
      _client2.default.confirmEmail(token)
        .catch((e) => setErrorMsg(
          errorMsgs[_optionalChain([e, 'optionalAccess', _3 => _3.response, 'optionalAccess', _4 => _4.Error])] || errorMsgs.generic,
        ))
        .then(() => setIsLoading(false))
    },
    [token],
  )

  const renderContent = () => {
    if (isLoading) {
      return (
        _react2.default.createElement('div', { className: "auth-stack auth-loading" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
          , _react2.default.createElement(_Spinner.SimpleSpinner, { className: "auth-loading--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} )
          , _react2.default.createElement('h1', { className: "auth-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "Confirming your email address…"   )
        )
      )
    }
    if (errorMsg) {
      return (
        _react2.default.createElement(_AuthFrame.ResultCard, { tone: "bad", title: "Failed to confirm email address"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
          , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}},  errorMsg )
          , _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.ROOT, className: "blm-btn blm-btn--primary" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "Back to BloomText"  )
        )
      )
    }
    return (
      _react2.default.createElement(_AuthFrame.ResultCard, { tone: "ok", title: "Success!", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
        , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "BloomText has confirmed your email address."     )
        , _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.INBOX.ROOT, className: "blm-btn blm-btn--primary" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Back to BloomText"  )
      )
    )
  }

  return (
    _react2.default.createElement(_AuthFrame.AuthFrame, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
      ,  renderContent() 
    )
  )
}

exports. default = ConfirmEmailScreen
